import { axiosInstanceTemplates } from "../instance";
import { AxiosResponse } from "../interface";
import { putTemplateWebsiteInterface } from "./s3TemplateWebsitesInterface";

export const putTemplateWebsite = async (data: putTemplateWebsiteInterface) => {
  const response: AxiosResponse = await axiosInstanceTemplates.put(`/s3-partition`, data);
  return response.data;
};

export const getTemplateWebsite = async (data: {
  schema_partition: string;
}) => {
  const response: AxiosResponse = await axiosInstanceTemplates.post(`/s3-partition`, data);
  return response.data;
};